import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import Home from "./home/Home";
import Help from "./help/Help";
import Alliance from "./alliance/Alliance";
import Pricing from "./pricing/Pricing";
import Voucher from "./voucher/Voucher";
import VoucherHeader from "./header/VoucherHeader";

function App() {
  return (
    <>
      <Switch>
        <Route
          exact
          path="/"
          render={() => (
            <>
              <Header />
              <Home />
            </>
          )}
        ></Route>
        <Route
          exact
          path="/help"
          render={() => (
            <>
              <Header />
              <Help />
            </>
          )}
        ></Route>
        <Route
          exact
          path="/alliance"
          render={() => (
            <>
              <Header />
              <Alliance />
            </>
          )}
        ></Route>
        <Route
          exact
          path="/pricing"
          render={() => (
            <>
              <Header />
              <Pricing />
            </>
          )}
        ></Route>
        <Route
          exact
          path="/voucher"
          render={() => (
            <>
              <VoucherHeader />
              <Voucher />
            </>
          )}
        ></Route>
        <Route path="*">
          <Redirect to="/" />
        </Route>
      </Switch>
      <Footer />
    </>
  );
}

export default App;
